import FullSite from "./full-site";
import { PrematchEventTemplate } from "../../jamibet/desktop-pages/prematch-event";

export default function PrematchEvent(props) {
	return <FullSite><PrematchEventTemplate {...props} /></FullSite>;
}
